import { render, staticRenderFns } from "./ShipmentConfirm.vue?vue&type=template&id=4070609b&scoped=true"
import script from "./ShipmentConfirm.vue?vue&type=script&lang=js"
export * from "./ShipmentConfirm.vue?vue&type=script&lang=js"
import style0 from "./ShipmentConfirm.vue?vue&type=style&index=0&id=4070609b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4070609b",
  null
  
)

export default component.exports